import Constants from './Model/constants';

/* eslint-disable i18next/no-literal-string */
const constants: Constants = {
  sensors_type: {
    atmotube: {
      key: 'Atmotube',
      value: 'AB'
    },
    airly_pm: {
      key: 'Airly PM',
      value: 'AP'
    },
    airly_pm_no2_03: {
      key: 'Airly PM + Gas (NO2, O3)',
      value: 'A1'
    },
    airly_pm_so2_co: {
      key: 'Airly PM + Gas (SO2, CO)',
      value: 'A2'
    },
    wiseair: {
      key: 'Wiseair',
      value: 'WA'
    },
    awair: {
      key: 'Awair',
      value: 'AW',
      calibration_params: [
        { name: 'latitude', type: 'number' },
        { name: 'longitude', type: 'number' }
      ]
    },
    airqino: {
      key: 'Airqino',
      value: 'AQ',
      calibration_params: [
        {
          name: 'co',
          type: 'object',
          children: [
            { name: 'a', type: 'number', default: 0.33 },
            { name: 'b', type: 'number', default: -1.655 }
          ]
        },
        {
          name: 'pm10',
          type: 'object',
          children: [
            { name: 'a', type: 'number', default: 0.9375 },
            { name: 'b', type: 'number', default: 0.682 }
          ]
        },
        {
          name: 'o3',
          type: 'object',
          children: [
            { name: 'a', type: 'number', default: 22.524 },
            { name: 'b', type: 'number', default: -52.628 }
          ]
        },
        {
          name: 'pm25',
          type: 'object',
          children: [
            { name: 'a', type: 'number', default: 1.1225 },
            { name: 'b', type: 'number', default: 0.983 }
          ]
        },
        {
          name: 'no2',
          type: 'object',
          children: [
            { name: 'a', type: 'number', default: 0.965 },
            { name: 'b', type: 'number', default: 0.56 }
          ]
        }
      ]
    },
    kaiterra: {
      key: 'Kaiterra',
      value: 'KA',
      calibration_params: [
        { name: 'apikey', type: 'string' }
      ]
    }
  },
  keycloak: {
    url: process.env.REACT_APP_KEYCLOAK_URL!,
    realm: process.env.REACT_APP_KEYCLOAK_REALM!,
    clientId: process.env.REACT_APP_IP_CLIENT_ID!,
    role: 'pw-sensors'
  },
  api: {
    base: `${process.env.REACT_APP_BASE_URL}/api`,
    getAggregateSales: `${process.env.REACT_APP_BASE_URL}/api/stats/aggregate/sales`,
    getDashboard: `${process.env.REACT_APP_BASE_URL}/api/sensors/dashboard`, // GET
    getAccountsDashboard: `${process.env.REACT_APP_BASE_URL}/api/algorand/dashboard`, // GET
    getMySensors: `${process.env.REACT_APP_BASE_URL}/api/sensors/my`, // GET
    getSensors: `${process.env.REACT_APP_BASE_URL}/api/sensors/`, // GET
    getTempSensors: `${process.env.REACT_APP_BASE_URL}/api/sensors/temporary`, // GET
    addSensors: `${process.env.REACT_APP_BASE_URL}/api/sensors/`, // POST
    getContacts: `${process.env.REACT_APP_BASE_URL}/api/contacts/contacts`,
    getContact: `${process.env.REACT_APP_BASE_URL}/api/contacts/contacts/{contactId}`,
    getLocationsByContact: `${process.env.REACT_APP_BASE_URL}/api/contacts/locations/mail/`, // GET,
    getOrders: `${process.env.REACT_APP_BASE_URL}/api/orders`, // GET,
    getOrder: `${process.env.REACT_APP_BASE_URL}/api/orders`, // GET,
    getPersonalContacts: `${process.env.REACT_APP_BASE_URL}/api/contacts/personal`, // GET
    addPersonalContact: `${process.env.REACT_APP_BASE_URL}/api/contacts/personal`, // POST
    getBusinessContacts: `${process.env.REACT_APP_BASE_URL}/api/contacts/business`, // GET
    getBusinessContactDetail: `${process.env.REACT_APP_BASE_URL}/api/contacts/business/{id}`, // GET
    addBusinessContactLink: `${process.env.REACT_APP_BASE_URL}/api/contacts/business/{businessId}/{personalId}`, // POST
    deleteBusinessContactLink: `${process.env.REACT_APP_BASE_URL}/api/contacts/business/{businessId}/{personalId}`, // DELETE
    addBusinessContact: `${process.env.REACT_APP_BASE_URL}/api/contacts/business`, // POST
    getAlgorandAccounts: `${process.env.REACT_APP_BASE_URL}/api/contacts/algoaccounts`, // GET
    getSensorsOwners: `${process.env.REACT_APP_BASE_URL}/api/sensors/owners`, // GET
    promoteSensor: `${process.env.REACT_APP_BASE_URL}/api/sensors/{sensorId}/promote`,
    addOwnerPersonalDeviceLink: `${process.env.REACT_APP_BASE_URL}/api/sensors/{sensorId}/owner/personal/{personalId}`, // POST
    addOwnerBusinessDeviceLink: `${process.env.REACT_APP_BASE_URL}/api/sensors/{sensorId}/owner/business/{businessId}`, // POST
    deleteOwnerPersonalDeviceLink: `${process.env.REACT_APP_BASE_URL}/api/sensors/{sensorId}/owner/personal`, // DELETE
    deleteOwnerBusinessDeviceLink: `${process.env.REACT_APP_BASE_URL}/api/sensors/{sensorId}/owner/business`, // DELETE
    addInfrastructurePersonalDeviceLink:
      `${process.env.REACT_APP_BASE_URL}/api/sensors/{sensorId}/infrastructure/personal/{personalId}`, // POST
    addInfrastructureBusinessDeviceLink:
      `${process.env.REACT_APP_BASE_URL}/api/sensors/{sensorId}/infrastructure/business/{businessId}`, // POST
    deleteInfrastructurePersonalDeviceLink: `${process.env.REACT_APP_BASE_URL}/api/sensors/{sensorId}/infrastructure/personal`, // DELETE
    deleteInfrastructureBusinessDeviceLink: `${process.env.REACT_APP_BASE_URL}/api/sensors/{sensorId}/infrastructure/business`, // DELETE
    refreshKycOnboarding: `${process.env.REACT_APP_BASE_URL}/api/kyc/{id}/refresh`, // GET
    getKycInfos: `${process.env.REACT_APP_BASE_URL}/api/kyc/dashboard`,
    initKycAccount: `${process.env.REACT_APP_BASE_URL}/api/kyc/init/{email}`,
    getBetatesters: `${process.env.REACT_APP_BASE_URL}/api/betatesters/`, // GET
    addBetatester: `${process.env.REACT_APP_BASE_URL}/api/betatesters/`, // POST
    fixPin: `${process.env.REACT_APP_BASE_URL}/api/sensors/{sensorId}/fixpin`, // PUT
    addOrder: `${process.env.REACT_APP_BASE_URL}/api/orders/order`, // POST
    getSensorFEHistory: `${process.env.REACT_APP_BASE_URL}/api/airquino/sensor`, // GET
    getSensorsFE: `${process.env.REACT_APP_BASE_URL}/api/airquino/sensors`, // GET
    getPurchasesCounts: `${process.env.REACT_APP_BASE_URL}/api/orders/count`, // GET
    getProductTypes: `${process.env.REACT_APP_BASE_URL}/api/productTypes`, // GET
    getPaymentTypes: `${process.env.REACT_APP_BASE_URL}/api/paymentTypes`, // GET
    getProductTypesCount: `${process.env.REACT_APP_BASE_URL}/api/stats/product-types/count`, // GET
    addOrderFull: `${process.env.REACT_APP_BASE_URL}/api/orders/full-order`, // POST
    deleteOrder: `${process.env.REACT_APP_BASE_URL}/api/orders`, // POST
    updateOrderFull: `${process.env.REACT_APP_BASE_URL}/api/orders/full-order`, // PUT
    getExportOrders: `${process.env.REACT_APP_BASE_URL}/api/orders/export`, // GET
    deleteDeviceOwner: `${process.env.REACT_APP_BASE_URL}/api/support/devices/{deviceId}/sold`, // POST
    getLicenses: `${process.env.REACT_APP_BASE_URL}/api/licenses/`, // GET
    freeLicense: `${process.env.REACT_APP_BASE_URL}/api/support/licenses/{licenseId}/free/`, // GET
    moveNfts: `${process.env.REACT_APP_BASE_URL}/api/support/account/{account}/movenfts`, // POST
    changeAccount: `${process.env.REACT_APP_BASE_URL}/api/support/account/mnemoniclost/`, // POST
    nftMove: `${process.env.REACT_APP_BASE_URL}/api/support/nft/{nftId}/move`, // POST
    changeMail: `${process.env.REACT_APP_BASE_URL}/api/support/licenses/{licenseId}/changeMail`, // POST
    changeLicenseExpirationDate: `${process.env.REACT_APP_BASE_URL}/api/licenses/{licenseId}/date`, //PATCH
    changeMailOrder: `${process.env.REACT_APP_BASE_URL}/api/support/order/{orderId}/changeMail`, // POST
    downloadZipInvoice: `${process.env.REACT_APP_BASE_URL}/api/orders/invoices`, // GET
    clawback: `${process.env.REACT_APP_BASE_URL}/api/support/nft/{nftId}/clawback`, // POST
    changeMailSensor: `${process.env.REACT_APP_BASE_URL}/api/support/devices/{deviceId}/changemail`, // POST
    getTransactions: `${process.env.REACT_APP_BASE_URL}/api/transactions`, // GET
    getLicenseTransactions: `${process.env.REACT_APP_BASE_URL}/api/licenseTransactions`, // GET
    updateTransaction: `${process.env.REACT_APP_BASE_URL}/api/transactions`, // PUT
    trackTransaction: `${process.env.REACT_APP_BASE_URL}/api/transactions/import`, // POST
    exportTransaction: `${process.env.REACT_APP_BASE_URL}/api/transactions/export/xlsx`, // POST
    getSyncOrders: `${process.env.REACT_APP_BASE_URL}/api/transactions/orders-sync`, // GET
    saveSyncOrders: `${process.env.REACT_APP_BASE_URL}/api/transactions/orders-sync`, // PUT
    banDevice: `${process.env.REACT_APP_BASE_URL}/api/support/devices/{deviceId}/ban`, // POST
    banMail: `${process.env.REACT_APP_BASE_URL}/api/support/contacts/{mail}/ban`, // POST
    addContact: `${process.env.REACT_APP_BASE_URL}/api/contacts`,
    getCompanies:  `${process.env.REACT_APP_BASE_URL}/api/companies`, //GET
    getLicensesHistory: `${process.env.REACT_APP_BASE_URL}/api/licenses/history`,
    getSensorsLicensesReport: `${process.env.REACT_APP_BASE_URL}/api/stats/sensors-licenses-overview/xlsx`,
    totalTransactions: `${process.env.REACT_APP_BASE_URL}/api/transactions/overview`, // GET
    mergeContact: `${process.env.REACT_APP_BASE_URL}/api/support/contacts/{contactMail}/merge`, // POST
    checkData: `${process.env.REACT_APP_BASE_URL}/api/support/devices/{deviceId}/checkdata`, // GET
    addBusiness: `${process.env.REACT_APP_BASE_URL}/api/companies/company`, //POST
    updateBusiness: `${process.env.REACT_APP_BASE_URL}/api/companies/company/{companyId}`, // PUT
    sensorDiagnostic: `${process.env.REACT_APP_BASE_URL}/api/support/devices/:deviceId/diagnostic`,
    getAlgoAccount: `${process.env.REACT_APP_ALGO_API}/v2/accounts/{accountId}`, //GET
    getTransactionAccount: `${process.env.REACT_APP_ALGO_API}/v2/accounts/{accountId}/transactions`, //GET
    getAlgoInfo: `${process.env.REACT_APP_ALGO_API}/v2/transactions/{txId}`, //GET
    enableKYB: `${process.env.REACT_APP_BASE_URL}/api/kyb/{companyContactId}`, //POST
    disableKYB: `${process.env.REACT_APP_BASE_URL}/api/kyb/{companyContactId}`, //DELETE
    getSensorLicenses: `${process.env.REACT_APP_BASE_URL}/api/licenses/sensors/:sensorId`, //GET
    updateContact: `${process.env.REACT_APP_BASE_URL}/api/contacts`,
    getCompaniesByContact: `${process.env.REACT_APP_BASE_URL}/api/contacts/:id/companies`,
    createContactCompany: `${process.env.REACT_APP_BASE_URL}/api/contacts/:id/companies`,
    deleteContactCompany: `${process.env.REACT_APP_BASE_URL}/api/contacts/:id/companies/:company_id`,
    importSensors: `${process.env.REACT_APP_BASE_URL}/api/sensors/import/csv`,
    generateBillingCodes: `${process.env.REACT_APP_BASE_URL}/api/invoices/generate-invoices-codes`,
    generateCreditNoteCodes: `${process.env.REACT_APP_BASE_URL}/api/invoices/generate-credit-note-codes`,
    getKycStatistic: `${process.env.REACT_APP_BASE_URL}/api/stats/kyc`, // GET
    getPurcheseInfo: `${process.env.REACT_APP_BASE_URL}/api/stats/purchase-info`, // GET
    getSensorCountByContry: `${process.env.REACT_APP_BASE_URL}/api/stats/continents/sensors-counter`, // GET
    getProductsCounter: `${process.env.REACT_APP_BASE_URL}/api/stats/continents/products-counter`, // GET
    getMissingNfts: `${process.env.REACT_APP_BASE_URL}/api/support/contacts/{contactMail}/missingnfts`, //GET
    getOrderPayments: `${process.env.REACT_APP_BASE_URL}/api/orders/{orderId}/payments`, //GET
    getOrderCreditNotes: `${process.env.REACT_APP_BASE_URL}/api/orders/{orderId}/credit-notes`, //GET
    getOrderCreditNote: `${process.env.REACT_APP_BASE_URL}/api/credit-notes/{id}`, //GET
    getPayment: `${process.env.REACT_APP_BASE_URL}/api/payments/{paymentId}`, //GET
    dowloadPaymentInvoice: `${process.env.REACT_APP_BASE_URL}/api/invoices/{paymentId}`,
    getProductCurrency: `${process.env.REACT_APP_BASE_URL}/api/productTypes/{id}/currencies/{currency}`, //GET
    addPayment: `${process.env.REACT_APP_BASE_URL}/api/payments`, //POST
    updatePayment: `${process.env.REACT_APP_BASE_URL}/api/payments`, //PUT
    deletePayment: `${process.env.REACT_APP_BASE_URL}/api/payments/{paymentId}`, // DELETE
    addCreditNote: `${process.env.REACT_APP_BASE_URL}/api/credit-notes`, //POST
    updateCreditNote: `${process.env.REACT_APP_BASE_URL}/api/credit-notes`, //PUT
    searchContacts: `${process.env.REACT_APP_BASE_URL}/api/contacts/{email}`, //GET
    getSensorsTestingData: `${process.env.REACT_APP_BASE_URL}/api/sensors/{type}/testing`, //GET
    getSensorTestingHistory: `${process.env.REACT_APP_BASE_URL}/api/sensors/{id}/history`, //GET
    getLicensesReport: `${process.env.REACT_APP_BASE_URL}/api/licenses/report/xlsx`, //GET
    orderRefudable: `${process.env.REACT_APP_BASE_URL}/api/orders/{id}/refundable`, //GET
    getAwairElementInfo: `${process.env.REACT_APP_BASE_URL}/api/sensors/awair/refunds-coupons`,
    downloadCreditNote: `${process.env.REACT_APP_BASE_URL}/api/invoices/{creditNoteId}/credit-note`,
    getSensorTypesOnlySensors: `${process.env.REACT_APP_BASE_URL}/api/sensorTypes` //GET
  },
  add_sensors: {
    infrastructure_percentage: 20,
    // eslint-disable-next-line max-len
    importCSVSensorsSample: 'data:text/csv;charset=utf-8,Sensor Type;Sensor ID;Owner email;Owner Algorand account;Infrastructure email;Infrastructure Algorand account;ICCID;Infrastructure percentage;KAI:apiKey'
  },
  transaction: {
    address: 'CG7CUMAJWSTIP4KPQHWIII7QEASDQTGSOYRPRJ4WX7QZ7OQDCNZPJSNLHE',
    recicleBinType1: 'XZCXGFV4UF23V7H3QYZL7WY6MEIKHN7GCTMAI4SGUD5Z7ES7GN7ZQRCH4U',
    recicleBinType2: '2WNL7VV5N5W4IXWSK6WLCRUJC6XDSLN2YCCIJQONJ55FXSYWL4FTMNPDFQ',
    recicleBinType3: 'E7BS6EZBZ6YY5A5Z2TQPBHPWX7JUQFU5PIEC2OZ2WCX7NZJIL2SQAHWUDI',
    recicleBinType4: '4MHPEW37YWVH2CIIHWHVMDOAHDRPZBL6NEXEPWOCXDVRNZHYW667PQAXKA',
    burning: 'KLMUOBJ3ARW22Q2D43LK2OVISHUIWC6RNA77AU3PO4KWB5KKIVDWXZA354',
    rewarder: 'ZW3ISEHZUHPO7OZGMKLKIIMKVICOUDRCERI454I3DB2BH52HGLSO67W754'
  },
  nodeExplorer: {
    account: 'https://app.dappflow.org/explorer/account/${account}'
  }
};

export default constants;